{
  "SET_NEW_PASSWORD": {
    "TITLE": "Новий пароль",
    "PASSWORD": {
      "LABEL": "Пароль",
      "PLACEHOLDER": "Пароль",
      "ERROR": "Пароль занадто короткий."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Підтвердити пароль",
      "PLACEHOLDER": "Підтвердження пароля",
      "ERROR": "Паролі не збігаються."
    },
    "API": {
      "SUCCESS_MESSAGE": "Пароль успішно змінено.",
      "ERROR_MESSAGE": "Не вдалося підключитися до Woot сервера. Будь ласка, спробуйте ще раз."
    },
    "CAPTCHA": {
      "ERROR": "Верифікація закінчилася. Будь ласка, пройдіть captcha ще раз."
    },
    "SUBMIT": "Додати"
  }
}
